import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Browse Product Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Select a category below or use the dropdown to explore our complete collection of products on Hipobuy Sheet
          </p>
        </div>

        <div className="flex justify-center mb-12">
          <div className="relative w-full max-w-md" ref={dropdownRef}>
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="w-full flex items-center justify-between bg-background-100 border border-background-200/80 rounded-lg px-5 py-3.5 text-foreground-800 text-sm font-medium hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <i className="ri-menu-search-line text-lg"></i>
                Select a Category
              </span>
              <i className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}></i>
            </button>

            {dropdownOpen && (
              <div className="absolute top-full mt-2 left-0 w-full bg-background-50 border border-background-200/80 rounded-lg overflow-hidden z-30 max-h-[360px] overflow-y-auto">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setDropdownOpen(false)}
                    className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
                  >
                    <i className={`${cat.icon} text-base w-5 h-5 flex items-center justify-center`}></i>
                    {cat.name}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2.5 p-4 md:p-5 bg-background-50 border border-background-200/60 rounded-lg hover:border-primary-300 hover:bg-background-100 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors duration-200">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-900 text-center whitespace-nowrap transition-colors duration-200">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}